export default __webpack_public_path__ + "static/media/academy_year_mobile.9587b4e9.svg";